import { Question, Product } from './types';

export const questions: Question[] = [
  {
    text: 'Where do you experience pain most often?',
    options: [
      'Joints (knees, hips, fingers)',
      'Muscles (back, shoulders, legs)',
      'Feet (heels, arches, toes)',
      'Nerve pain (sharp, shooting discomfort)',
      'General aches & stiffness'
    ],
    type: 'multiple'
  },
  {
    text: 'How would you describe your pain?',
    options: [
      'Occasional soreness or stiffness',
      'Chronic or persistent discomfort',
      'Sharp, sudden pain',
      'Post-workout or overuse soreness'
    ],
    type: 'single'
  },
  {
    text: 'What\'s most important to you in a pain relief product?',
    options: [
      'Fast-acting, numbing relief',
      'Long-lasting support for everyday pain',
      'Hands-free, mess-free application',
      'Deep-penetrating moisture for skin & joints'
    ],
    type: 'single'
  },
  {
    text: 'How do you prefer to apply your pain relief?',
    options: [
      'Cream that absorbs fast',
      'Spray for hands-free relief'
    ],
    type: 'single'
  }
];

export const products: Record<keyof Omit<Scores, keyof {}>, Product> = {
  score_Original: {
    name: 'Blue-Emu Original',
    description: 'Deep-penetrating formula with emu oil to support tired muscles and joints',
    link: 'https://www.blue-emu.com/product/blue-emu-original-super-strength-2-oz/'
  },
  score_MaxPain: {
    name: 'Blue-Emu Maximum Pain Relief Cream',
    description: 'Maximum-strength formula with Trolamine Salicylate for long-lasting comfort',
    link: 'https://www.blue-emu.com/product/blue-emu-maximum-pain-relief-cream/'
  },
  score_Spray: {
    name: 'Blue-Emu Continuous Pain Relief Spray',
    description: 'Hands-free spray that absorbs fast for mess-free muscle and joint support',
    link: 'https://www.blue-emu.com/product/blue-emu-continuous-pain-relief-spray-4-oz/'
  },
  score_Lidocaine: {
    name: 'Blue-Emu Lidocaine Pain Cream',
    description: 'Fast-acting, targeted pain relief to keep discomfort at bay for up to 8 hours',
    link: 'https://www.blue-emu.com/product/blue-emu-lidocaine-pain-cream/'
  },
  score_UltraHemp: {
    name: 'Blue-Emu Ultra Pain Relief Cream with Hemp',
    description: 'Enriched with Trolamine Salicylate and hemp seed oil for deep, effective relief',
    link: 'https://www.blue-emu.com/product/blue-emu-ultra-pain-relief-cream-with-hemp-seed-oil-3-oz/'
  },
  score_FootTherapy: {
    name: 'Blue-Emu Foot Therapy',
    description: 'Rich, hydrating formula packed with skin-loving ingredients to revitalize tired feet',
    link: 'https://www.blue-emu.com/product/blue-emu-foot-therapy-5-5-oz/'
  }
};